import { useI18n } from "../i18n/I18nContext.jsx";

// Color mapping for all paragraph, zone, and review status codes.
const STATUS_COLORS = {
  PENDING: "red",
  IN_PROGRESS: "red",
  REPLY_SUBMITTED: "green",
  SUBMITTED: "green",
  RESOLVED: "blue",
  CLOSED: "blue",
  COMPLETED: "blue",
  ACCEPTED: "blue",
  REOPENED: "amber",
  REJECTED: "amber",
  CLARIFICATION: "amber",
};

export default function StatusBadge({ status }) {
  const { t } = useI18n();
  if (!status) return <span className="badge grey">—</span>;
  const key = String(status).toUpperCase();
  const color = STATUS_COLORS[key] || "grey";
  const label = t(`status${key}`) || status;
  return (
    <span className={`badge ${color}`}>
      <span className="badge-dot" />
      {label}
    </span>
  );
}
